export default __webpack_public_path__ + "static/media/money-black.1d20e8e8.svg";